import React, { useEffect } from 'react';
import { initPixel } from './components/pixel';
import { Hero } from './components/sections/Hero';
import { PainSection } from './components/sections/PainSection';
import { ReframeSection } from './components/sections/ReframeSection';
import { WhatIsItSection } from './components/sections/WhatIsItSection';
import { TomosSection } from './components/sections/TomosSection';
import { ForWhoSection } from './components/sections/ForWhoSection';
import { TestimonialsSection } from './components/sections/TestimonialsSection';
import { BonusSection } from './components/sections/BonusSection';
import { ValueComparisonSection } from './components/sections/ValueComparisonSection';
import { OfferSection } from './components/sections/OfferSection';
import { GuaranteeSection } from './components/sections/GuaranteeSection';
import { FaqSection } from './components/sections/FaqSection';
import { ClosingSection } from './components/sections/ClosingSection';
import { SocialProofPopup } from './components/ui/SocialProofPopup';
import { StickyMobileCta } from './components/ui/StickyMobileCta';
export function App() {
  useEffect(() => {
    initPixel();
  }, []);
  return <div className="min-h-screen bg-brand-sand font-sans text-brand-charcoal selection:bg-brand-teal selection:text-white pb-20 md:pb-0" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <PainSection data-id="element-3" />
        <ReframeSection data-id="element-4" />
        <WhatIsItSection data-id="element-5" />
        <TomosSection data-id="element-6" />
        <ForWhoSection data-id="element-7" />
        <TestimonialsSection data-id="element-8" />
        <BonusSection data-id="element-9" />
        <ValueComparisonSection data-id="element-10" />
        <OfferSection data-id="element-11" />
        <GuaranteeSection data-id="element-12" />
        <FaqSection data-id="element-13" />
        <ClosingSection data-id="element-14" />
      </main>

      <SocialProofPopup data-id="element-15" />
      <StickyMobileCta data-id="element-16" />
    </div>;
}